import { baseApi, API_TAGS } from '@/shared/api';
import { type WarehouseResponse, type DashboardOptions, createDashboardEndpointBuilder } from '@/entities/dashboard';

const warehouseEndpoint = createDashboardEndpointBuilder('/warehouse');

export const warehouseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWarehouse: builder.query<WarehouseResponse, DashboardOptions | undefined>({
      query: (options) => ({
        url: warehouseEndpoint(''),
        params: options
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.STORAGE]
    })
  })
});

export const { useGetWarehouseQuery } = warehouseApi;
